// extracted by mini-css-extract-plugin
module.exports = {"belongTrailingCell":"price-table_belongTrailingCell__yi_bn","belongItemCell":"price-table_belongItemCell__nPc69"};